import { SYSTEM_VARIABLE_CATALOG, filterVariablesBySearch, isSystemVariable, normalizeVariableLabel } from '../TemplateVariables.utils';
export const CATEGORY_ORDER = [
    'Client',
    'My Business',
    'Agreement'
];
function filterSystemVariables(search) {
    const trimmed = search.trim();
    if (!trimmed) {
        return [
            ...SYSTEM_VARIABLE_CATALOG
        ];
    }
    const normalizedSearch = normalizeVariableLabel(trimmed);
    return SYSTEM_VARIABLE_CATALOG.filter((entry)=>normalizeVariableLabel(entry.label).includes(normalizedSearch));
}
function groupSystemVariablesByCategory(filteredSystemVars) {
    const grouped = new Map();
    for (const category of CATEGORY_ORDER){
        const labels = filteredSystemVars.filter((v)=>v.category === category).map((v)=>v.label);
        if (labels.length > 0) {
            grouped.set(category, labels);
        }
    }
    return grouped;
}
export function buildSelectableItems(searchText, customVariables, excludeLabels) {
    const filteredSystem = filterSystemVariables(searchText).filter((v)=>!excludeLabels.has(normalizeVariableLabel(v.label)));
    const grouped = groupSystemVariablesByCategory(filteredSystem);
    const filteredCustom = filterVariablesBySearch(customVariables.map((label)=>({
            label
        })), searchText).map((v)=>v.label);
    const items = [];
    for (const [category, labels] of grouped){
        for (const label of labels){
            items.push({
                type: 'variable',
                label,
                category
            });
        }
    }
    for (const label of filteredCustom){
        items.push({
            type: 'variable',
            label,
            category: 'Custom'
        });
    }
    const trimmedSearch = searchText.trim();
    const searchMatchesExisting = trimmedSearch.length > 0 && (isSystemVariable(trimmedSearch) || customVariables.some((v)=>normalizeVariableLabel(v) === normalizeVariableLabel(trimmedSearch)));
    if (trimmedSearch.length > 0 && !searchMatchesExisting) {
        items.push({
            type: 'create',
            label: trimmedSearch
        });
    }
    return items;
}
export function getCategoryForItem(items, index) {
    const item = items[index];
    if (item.type !== 'variable') {
        return null;
    }
    if (index === 0) {
        return item.category;
    }
    const prevItem = items[index - 1];
    if (prevItem.type !== 'variable' || prevItem.category !== item.category) {
        return item.category;
    }
    return null;
}
